import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { setLanguage } from '@eb/i18n';
import { initializeRealUserMonitoring } from '@eb/real-user-monitoring';

import { default as Routes } from './pages/routes';

import { isProd } from './utils/http';

const FIVE_MINUTES = 5 * 60 * 1000;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
            staleTime: FIVE_MINUTES,
        },
    },
});

export default class DiscoverApp extends React.Component {
    constructor(props) {
        super(props);

        setLanguage(props.env.localeInfo.locale);
    }

    componentDidMount() {
        if (isProd(this.props)) {
            initializeRealUserMonitoring({
                sampleRate: 0.55,
                version: this.props.app_version,
                service: this.props.app_name,
            });
        }
    }

    render() {
        return <Routes {...this.props} />;
    }
}
